var _rect, _line, _line2, _line3, _line4, _line5, _line6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationIconGameAnalyzer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "24px-game-analyzer-01 copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 12,
    height: 12,
    rx: 3.5,
    strokeWidth: 2,
    stroke: "#343434",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 4,
    x2: 11,
    y2: 4,
    fill: "none",
    stroke: "#343434",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 11,
    x2: 4,
    y2: 22,
    fill: "none",
    stroke: "#343434",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 2,
    x2: 10,
    y2: 6,
    fill: "none",
    stroke: "#343434",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 2,
    x2: 23,
    y2: 6,
    fill: "none",
    stroke: "#343434",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 10,
    x2: 6,
    y2: 10,
    fill: "none",
    stroke: "#343434",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 23,
    x2: 6,
    y2: 23,
    fill: "none",
    stroke: "#343434",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationIconGameAnalyzer);
export default __webpack_public_path__ + "static/media/navigation-icon-game-analyzer.021cf61b694128e0664e4268d854fc89.svg";
export { ForwardRef as ReactComponent };